
import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import Header from "./header"
import Footer from "./footer"

function Layout({ location, children }) {
  // TODO: add logo info: https://developers.google.com/search/docs/advanced/structured-data/logo
  return (
    <>
      <Helmet
        htmlAttributes={{
          class: 'scroll-smooth'
        }}
        bodyAttributes={{
          class: 'overflow-x-hidden font-sans text-base bg-white text-neutral-400'
        }}
        link={[
          {
            rel: "preconnect",
            href: "https://fonts.googleapis.com"
          },
          {
            rel: "preconnect",
            href: "https://fonts.gstatic.com",
            crossOrigin: ""
          },
          {
            rel: "stylesheet",
            href: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,300;0,400;0,500;0,700;1,400&display=swap"
          }
        ]}
        script={[
          {
            // TODO: parametrize host/url in course layout
            dataDomain: "extremeautomation.io",
            src: "https://plausible.io/js/script.outbound-links.file-downloads.js",
            defer: true
          }
        ]} >
      </Helmet>
      { /* TODO: add breadcrumb: https://developers.google.com/search/docs/advanced/structured-data/breadcrumb#json-ld */}
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `
        _linkedin_partner_id = "6252721";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `}} />  
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `
        (function(l) {
          if (!l){window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);})(window.lintrk);
      `}} />
      <a className="sr-only" href="#main-content">Skip to content</a>
      <Header location={location} />
      <main id="main-content" className="container mt-2 md:mt-11">{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default Layout
